<template>
    <div>
        <table width="100%" class="tableheatmap">
            <tr>
                <th :width="cellWidth" v-for="col_label in chartData.col_labels_display_ready"><strong>{{col_label}}</strong></th>
            </tr>
            <tr v-for="row in chartData.rows_display_ready">
              <td style="color:gray" v-if="row.show_row_num">{{row.row_num}}</td>
              <td :width="cellWidth" class="first" style="text-align:right;"><strong>{{row.label}}</strong></td>
                <td :width="cellWidth" v-for="cell in row.cells">
                    <div @click="click(row.label,cell.label)">
                        <TableHeatmapCell
                                :value="cell.value"
                                :display_value="cell.display_value"
                                :min="chartData.min_value"
                                :max="chartData.max_value"
                                :heatmappable="cell.heatmappable"
                                :type="cell.type"
                                :max_background_color="cell.max_background_color"
                        />
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "TableHeatmap",
        props: ['height','width', 'text_size', 'chartData'],
        computed: {
            cellWidth: function () {
                let percent = 100 / this.chartData.col_labels_display_ready.length
                return percent.toString() + '%'
            },
        },
        methods: {
            click(row,column) {
                let payload = {
                    label: row,
                    color: column
                }
                this.$emit('stackChartClicked',payload);
            }
        }
    }
</script>

<style scoped>

</style>